import { createStyles } from '@mantine/core';
import type { BiMetricVersionOut } from '@repo/api-codegen';
import { noop } from 'lodash-es';
import { QueryBlockContainer } from '../../../components/Editor/outline/src/components/QueryBlockContainer/QueryBlockContainer';

const useStyles = createStyles((theme) => ({
	sqlEditor: {
		borderRadius: theme.radius.sm,
	},
	sqlCode: {
		height: 460,
	},
}));

interface BIMetricSqlRenderProps {
	metricVersion: BiMetricVersionOut;
	onExecutionEnd?: (playgroundMetricId: string) => void;
	readOnly?: boolean;
}

export function BiMetricSqlRender({
	metricVersion,
	onExecutionEnd,
	readOnly = false,
}: BIMetricSqlRenderProps) {
	// TODO(nhanthai-dashboards): when this is rendered inside a modal, the autocompletion is whacked, need to fix
	return (
		<QueryBlockContainer
			id={metricVersion.sql_playground_id}
			readOnly={readOnly}
			onDelete={noop}
			noParentMode
			compactMode
			onExecutionEnd={onExecutionEnd}
		/>
	);
}
